module.exports = __webpack_public_path__ + "img/img50.b0a7efa1.png";